export type ScannedItem = {
  sku: string;
  scannedCount: number;
  overrideBin?: string;
};

export function getScannedCount(items: ScannedItem[], sku: string): number {
  return items.find((item) => item.sku === sku)?.scannedCount ?? 0;
}

export function incrementScannedItem(items: ScannedItem[], sku: string): ScannedItem[] {
  const idx = items.findIndex((item) => item.sku === sku);
  if (idx < 0) return [...items, { sku, scannedCount: 1 }];

  return items.map((item, itemIdx) =>
    itemIdx === idx ? { ...item, scannedCount: item.scannedCount + 1 } : item,
  );
}

export function setScannedItemOverride(items: ScannedItem[], sku: string, overrideBin: string): ScannedItem[] {
  const idx = items.findIndex((item) => item.sku === sku);
  if (idx < 0) return [...items, { sku, scannedCount: 0, overrideBin }];

  return items.map((item, itemIdx) =>
    itemIdx === idx ? { ...item, overrideBin } : item,
  );
}
